<template>
    <div class="inner-wrapper add-customer-section">
   <div class="page-title">
      <h1 class="float-left">Create Product</h1>
   </div>
   <div class="alert alert-success succ_msg" v-if="successMessage !=null">
        <strong class="success_msg">{{successMessage}}</strong>
    </div>
    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <ul>
            <li v-for="(v, k) in commonErrors" :key="k">
            <p v-for="error in v" :key="error" class="text-sm">
            {{ error }}
            </p>
            </li>
        </ul>
    </div>
   <ValidationObserver v-slot="{ handleSubmit }">
   <form @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">
      <div class="new-rfq">
        <div class="mb-4 row">

            <div class="col-lg-6 col-md-6">
                <div class="card panel create-box shadow-sm mb-3">

                    <div class="card-body">

                        <!-- <h2 class="mb-3 inner-title">Company Information</h2> -->
                        <div class="">
                            <div class="form-group flex-fill">
                                <label>Product Number</label>
                                <validation-provider rules="required|positive" v-slot="{ errors }">
                                    <input type="text" class="form-control"  placeholder="" name="website" id="website" v-model="form.product_num" />
                                    <span class="error-message">{{ errors[0] }}</span>
                                </validation-provider>
                            </div>
                            <div class="form-group flex-fill">
                                <label>Product Name</label>
                                <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.product_name">
                            </div>
                            <div class="form-group flex-fill">
                                <label>Product Description</label>
                                <ckeditor v-model="form.product_desc" :config="editorConfig"></ckeditor>

                            </div>

                            <div class="form-group flex-fill">
                                <label>Product Price</label>
                                <validation-provider rules="required|positive" v-slot="{ errors }">
                                <input type="text"  class="form-control" name="address" placeholder="" v-model="form.price">
                                 <span class="error-message">{{ errors[0] }}</span>
                                </validation-provider>
                            </div>
                            <div class="form-group flex-fill">
                                <label>Selling Price</label>
                                <validation-provider rules="required|positive" v-slot="{ errors }">
                                <input type="text"  class="form-control" name="address" placeholder="" v-model="form.selling">
                                <span class="error-message">{{ errors[0] }}</span>
                                </validation-provider>
                            </div>
                            <div class="form-group flex-fill">
                                <label>Old SKU</label>
                                <input type="text" class="form-control"  placeholder="" name="sku" id="sku" v-model="form.sku" />
                            </div>
                            <div class="form-group flex-fill">
                                <label>Customer SKU</label>
                                <input type="text" class="form-control"  placeholder="" name="customer_sku" id="customer_sku" v-model="form.customer_sku" />
                            </div>
                            <div class="form-group flex-fill">
                                <label>Vendor</label>
                                <validation-provider rules="required" v-slot="{ errors }">
                                <v-select placeholder="Search Vendor" label="company_name" v-model="form.vendor_id" :filterable="false" :options="options" :reduce="(option) => option.id" @search="onSearch">
                                    <template slot="no-options">
                                    Search Vendor
                                    </template>
                                    <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.company_name }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.company_name }}
                                    </div>
                                    </template>
                                </v-select>
                                <span class="error-message">{{ errors[0] }}</span>
                                </validation-provider>

                            </div>

                            <div class="form-group flex-fill">
                                <label for="status" class="mdl-textfield__label">Status </label>
                                <validation-provider rules="required" v-slot="{ errors }">
                                <select class="form-control mdl-textfield__input" id="status" name="status" v-model="form.status">
                                    <option value="1">Active</option>
                                    <option value="0">InActive</option>
                                </select>
                                 <span class="error-message">{{ errors[0] }}</span>
                                </validation-provider>
                            </div>


                        </div>
                    </div>
                </div>

                <div class="btnrow text-right">
                    <router-link :to="{name: 'viewProducts'}" class="btn skip-btn">Discard</router-link>
                    <button type="submit" class="btn custom-btn ml-3" id="save_customer_btn">Save</button>
                </div>

            </div>
        </div>

      </div>
   </form>
</ValidationObserver>

   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</div>
</template>

<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
extend('required', {
  ...required,
  message: 'This field is required'
});
extend('positive', value => {

  if (value >= 0) {
    return true;
  }
  return 'Please enter only number';
});
export default {
    name: "CustomerAdd",
    components: {
        ValidationProvider,ValidationObserver
    },
    created() {
       // this.getCountries();
        this.setSuccessMessage(null);
    },
    data(){
        return {
            editorConfig: {
                // The configuration of the editor.
            },
            countries: [],
            options:[],
            form: {
                product_name: null,
                price: null,
                product_desc: null,
                sku: null,
                customer_sku: null,
                product_num: null,
                vendor_id: null,
                selling: null,
                status:"1"
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        save() {

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('products.store'), this.form,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.form = {
                                product_name: null,
                                price: null,
                                product_desc: null,
                                sku: null,
                                customer_sku: null,
                                product_num: null,
                                vendor_id: null,
                                selling: null,
                            }
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.$router.push({ name: 'viewProducts' });
                        }, 3500);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                    vm.options = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
